import Skeleton from '@mui/material/Skeleton';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useProductCenterApi } from 'api';
import { recentlyVisitedQuery } from 'api/queries';

import HomeFooterColumnContainer from './HomeFooterColumnContainer';
import RecentlyVisited from './RecentlyVisited';

const RecentlyVisitedSection = (): React.JSX.Element => {
	const { api } = useProductCenterApi();
	const { t } = useTranslation(['home']);
	const { data, isLoading } = useQuery(recentlyVisitedQuery(api));

	const skeletonPlaceholder = (
		<Skeleton variant="text" width={200} height={48} animation="wave" />
	);

	return (
		<HomeFooterColumnContainer header={t('recently-visited')}>
			{isLoading ? (
				<>
					{skeletonPlaceholder}
					{skeletonPlaceholder}
					{skeletonPlaceholder}
					{skeletonPlaceholder}
					{skeletonPlaceholder}
				</>
			) : (
				(data?.map(
					({
						unitId,
						unitPublicId,
						unitDisplayTitle,
						drivelineId,
						chassisId,
						serialNumber,
					}) => (
						<RecentlyVisited
							unitPublicId={unitPublicId}
							unitTitle={unitDisplayTitle}
							drivelineId={drivelineId}
							chassisId={chassisId}
							serialNumber={serialNumber}
							key={`${unitId}+${drivelineId}${serialNumber}`}
						/>
					)
				) ?? <> </>)
			)}
		</HomeFooterColumnContainer>
	);
};

export default RecentlyVisitedSection;
